<script>
import {mapState} from "vuex";
import i18n from "@/i18n";
import AddressEdit from "@/components/ClientPicker/AddressEdit.vue";
import { VueTelInput } from 'vue-tel-input';
import {query} from "sinao-corejs";
import {getIndexesByContactEmail, validateEmail} from "@/mixins/methods";
import onboardingPopoverMixin from "@/mixins/onboardingPopoverMixin";
export default {
  components: {
    AddressEdit,
    VueTelInput
  },
  mixins: [onboardingPopoverMixin],
  props: {
    status: {
      type: Boolean,
      required: true,
      default: false
    },
    thirdAccount: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalRefName: "ModalCreatePerson" + (this.thirdAccount ? 'ThirdAccount' : ''),
      civilities:[
        { value:"M", text: i18n.t('M.') },
        { value:"Mme", text: i18n.t('Mme') },
        { value:"Dr", text: i18n.t('Dr.') },
        { value:"Dre", text: i18n.t('Dre.') },
        { value:"Me", text: i18n.t('Me.') },
        { value:"M. et Mme", text: i18n.t('M. et Mme') },
        { value:"", text: "-" }
      ]
    };
  },
  computed: {
    ...mapState({
      appId: state => state.app.id,
      token: state => state.app.token,
      editableEstablishment: state => state.contacts.editableEstablishment
    }),
    loadingContact: {
      get() {
        return this.$store.state.contacts.loadingContact;
      },
      set(value) {
        this.$store.commit("loadingContact", value);
      }
    },
    showCreatePersonModal: {
      get() {
        return this.$store.state.home.showCreatePersonModal;
      },
      set(value) {
        this.$store.commit("showCreatePersonModal", value);
      }
    },
    person: {
      get() {
        return this.$store.state.contacts.editableContact;
      },
      set(value) {
        this.$store.commit("editableContact", value);
      }
    }
  },
  mounted() {
  },
  methods: {
    closed() {
      this.onModalHidden();
      this.$store.commit('showCreatePersonModal', false)
      this.$store.commit('resetEditableContact');
      this.$store.commit('resetEditableEstablishment');
      this.$store.commit("renderGA", false);
    },
    opened() {
      this.onModalShow();
      this.$store.commit("renderGA", true);
    },
    async createPerson() {
      if (this.person.email.length && !validateEmail(this.person.email)) {
        this.$bvToast.toast(i18n.t('Email non valide'), {
          variant: "danger",
          solid: true
        });
        return;
      }
      this.loadingContact = true;
      try {
        const created_person = await query({
          operationId: "app.contacts.persons.create",
          token: this.token,
          params: {
            'appId': this.appId,
            'expand[0]': 'establishments',
            'expand[1]': 'establishments.contacts',
          },
          data: {
            lastname: this.person.lastname,
            firstname: this.person.firstname,
            civility: this.person.civility,
            establishments: [{
              email: this.person.email,
              phone: this.person.phone,
              place: {
                street_number: this.editableEstablishment.place.street_number || '',
                route: this.editableEstablishment.place.route || '',
                route2: this.editableEstablishment.place.route2 || '',
                postal_code: this.editableEstablishment.place.postal_code || '',
                locality: this.editableEstablishment.place.locality || '',
                country: this.editableEstablishment.place.country || ''
              }
            }]
          }
        });

        this.$bvToast.toast(i18n.t('Success_contact_add'), {
          variant: "success",
          solid: true
        });

        if (this.person.email) {
          // has an email was provided, an establishment with an establishment contact have been created
          // get the establishment and the contact indexes
          const { e_index, c_index } = getIndexesByContactEmail(created_person.establishments, this.person.email);

          if (e_index >= 0) {
            // set the contact id to the person
            created_person.establishment_id = created_person.establishments[e_index].id;
          }
          if (c_index >= 0) {
            created_person.establishment_contact_id = created_person.establishments[e_index].contacts[c_index].id;
            created_person.email = created_person.establishments[e_index].contacts[c_index].email;
          }
        }
        else {
          // has no email => just set the first establishment id has it is a new contact and normally have one establishment
          created_person.establishment_id = created_person.establishments[0].id;
        }
        this.$store.commit('updateContactInfos', { data: created_person, target: this.thirdAccount ? 'thirdAccount' : 'contactInfos' });

        this.$store.commit("resetEditableContact");
        this.$store.commit("resetEditableEstablishment");
        // close parent dialog
        this.$nextTick(() => {
          this.$emit("close");
        });

    } catch (error) {
      console.error(error);
      this.loadingContact = false;
    }
    this.loadingContact = false;
    }
  }
};
</script>

<template>
  <b-modal
      id="ModalCreatePerson"
      :ref="modalRefName"
      :visible="status"
      :ok-only="true"
      centered
      header-class="bg-modal-contact"
      footer-class="bg-modal-contact"
      size="sm"
      @close="closed"
      content-class="shadow"
      @hide="closed"
      @shown="opened"
  >
    <template #modal-header>
      <!-- Emulate built in modal header close button action -->
      <b-container style="max-width: 660px" class="p-0 mb-0">
        <b-row class="mb-0">
          <b-col cols="11" class="pl-0 mb-0">
            <b-container class="p-0 mb-0">
              <b-row class="p-0 mb-0">
                <b-col cols="1" style="margin-top: -0.3rem"><span style="font-size: 1.2rem"><b-icon icon="file-person" /></span></b-col>
                <b-col cols="11" class="pl-lg-0"><h5 style="margin: 0px">{{ $t('Ajouter un particulier') }}</h5></b-col>
              </b-row>
            </b-container>
          </b-col>
          <b-col cols="1 text-right pr-0">
            <div class="close_icon icon_square text-center" @click="closed">
              <b-icon icon="x" font-scale="0.9" class="px-0" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template #modal-footer>
      <!-- Emulate built in modal header close button action -->
      <b-container class="p-0">
        <b-row class="mb-0">
          <b-col class="text-right">
            <s-button
                type="border"
                style="width: auto"
                @click="closed"
            >
              {{ $t("Annuler") }}
            </s-button>
            <s-button
                type="success"
                style="width: auto"
                class="ml-2"
                :loading="loadingContact"
                :disabled="loadingContact || !person.lastname || !person.type"
                @click="createPerson"
            >
              {{ $t("Ajouter") }}
            </s-button>
          </b-col>
        </b-row>
      </b-container>
    </template>

    <b-container class="p-0">
      <!-- person information -->
      <b-row>
        <b-col cols="4">
          <b-form-select
              v-model="person.civility"
              :options="civilities"
              size="sm"
          />
        </b-col>
        <b-col cols="4">
          <b-form-input
              v-model="person.firstname"
              size="sm"
              :placeholder="$t('Prénom')"
          />
        </b-col>
        <b-col cols="4">
          <b-form-input
              v-model="person.lastname"
              size="sm"
              :placeholder="$t('Nom')"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-input
              v-model="person.email"
              size="sm"
              :placeholder="$t('Email')"
          /></b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <vue-tel-input
              v-model="person.phone"
              :input-options="{'placeholder': $t('Numéro de téléphone')}"
          />
        </b-col>
      </b-row>
      <b-row class="mt-0">
        <b-col cols="12"><hr></b-col>
      </b-row>

      <!-- person address -->
      <b-row>
        <AddressEdit map-id="createPerson" />
      </b-row>
    </b-container>
  </b-modal>
</template>

<style scoped lang="scss">
  .row {
    gap: 12px 8px;
    flex-wrap: nowrap;
    margin: 0px;
    margin-bottom: 12px;
  }

  .row > [class*="col"] {
    padding-left: 0;
    padding-right: 0;
  }

  .row > .col-4 {
    max-width: none !important;
    flex-basis: 0 !important;
    flex-grow: 1 !important;
    margin-bottom: 0px !important;
  }
</style>

<style>
  @media screen and (max-width: 750px) {
    #ModalCreatePerson .modal-dialog {
      margin: 0;
      max-width: 100%;
      height: 80vh;
      max-height: 80vh;
    }
    #ModalCreatePerson .modal-content {
      height: 80vh;
      max-height: 80vh;
      border-radius: 0;
      display: flex;
      flex-direction: column;
    }
    #ModalCreatePerson .modal-header {
      flex-shrink: 0;
    }
    #ModalCreatePerson .modal-body {
      flex: 1 1 0;
      min-height: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    #ModalCreatePerson .modal-footer {
      flex-shrink: 0;
    }
  }
</style>